import { createSelector } from 'reselect'
import { getSessionView } from '../../CandidateExperience/reducks/sessions'

export const currentState = createSelector(getSessionView, ({ current_state }) => current_state)
